module.exports = __webpack_public_path__ + "img/prem.9bdd8cbb.png";